import React from 'react'

import './FeatureList.scss'

const FeatureList = ({ list, className = '', style = {} }) => (
    <div className={`price-feature-list ${className}`} style={style}>
        {Object.entries(list).map(([key, option]) => (
            <div key={key}>
                <span>{option.name !== 'Ads free' ? option.name : 'Ad-free'}</span>
                {option.description === void 0 ? null : (
                    <span className="price-feature-list__description">{option.description}</span>
                )}
            </div>
        ))}
    </div>
)

export default FeatureList
